import React from 'react';
import moment from 'moment';
import { Typography } from '@mui/material';

import { CellDefaultProps } from '../../../types';
import { DateFormats } from '../../../../../constants/common';

export const DateCell = ({ proposal }: CellDefaultProps) => {
  return (
    <Typography component="span" variant="body2">
      {moment(proposal.createdDateTime).format(DateFormats.DateTimeShort12Hour)}
    </Typography>
  );
};
